/* tslint:disable */
/* eslint-disable */
/* @relayHash b60b9aaf5b462ce792cd43e8bfde4968 */

import { ConcreteRequest } from "relay-runtime";
export type DeleteMeetingAsInput = {
    meeting?: MeetingInputDelete | null;
};
export type MeetingInputDelete = {
    doNotify?: boolean | null;
    domainId: string;
    id: string;
    userId: string;
};
export type deleteMeetingAsMutationVariables = {
    input: DeleteMeetingAsInput;
};
export type deleteMeetingAsMutationResponse = {
    readonly deleteMeetingAs: {
        readonly errors: ReadonlyArray<{
            readonly key: string;
            readonly message: ReadonlyArray<string | null> | null;
            readonly reason: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly meeting: {
            readonly id: string;
            readonly userId: string;
            readonly domainId: string;
        } | null;
    } | null;
};
export type deleteMeetingAsMutation = {
    readonly response: deleteMeetingAsMutationResponse;
    readonly variables: deleteMeetingAsMutationVariables;
};



/*
mutation deleteMeetingAsMutation(
  $input: DeleteMeetingAsInput!
) {
  deleteMeetingAs(input: $input) {
    errors {
      key
      message
      reason
    }
    meeting {
      id
      userId
      domainId
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMeetingAsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMeetingAs",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMeetingAsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "InputError",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reason",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "meeting",
        "storageKey": null,
        "args": null,
        "concreteType": "Meeting",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "domainId",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "deleteMeetingAsMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "deleteMeetingAsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "deleteMeetingAsMutation",
    "id": null,
    "text": "mutation deleteMeetingAsMutation(\n  $input: DeleteMeetingAsInput!\n) {\n  deleteMeetingAs(input: $input) {\n    errors {\n      key\n      message\n      reason\n    }\n    meeting {\n      id\n      userId\n      domainId\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '6bc2c0dcc703e93fc0dbc39c237b8771';
export default node;
